





































































import { ModalOptions } from 'ant-design-vue/types/modal'
import { Guid } from 'guid-typescript'
import isImage from 'is-image'
import { snakeCase } from 'lodash'
import { lookup } from 'mime-types'
import { ValidationObserver, extend, localize } from 'vee-validate'
import Vue from 'vue'
import { Component, Prop, VModel, Watch, Ref } from 'vue-property-decorator'

import TextInput from '../Pi/fields/TextInput/TextInput.vue'
import { FieldData } from '../Pi/types'
import FilesList from './FilesList/FilesList.vue'
import { FileData, FileStatus } from './types'

@Component({
  components: {
    ValidationObserver,
    FilesList,
    TextInput,
  },
})
export default class FileUrlList extends Vue {
  @VModel({ type: Array }) fileUrls!: Array<string>

  @Prop() readonly availableMimeTypes!: Array<string>

  @Prop() readonly disabled!: boolean

  @Ref('fileLinkInput') readonly fileLinkInput!: any

  isAddFilePopupOpen = false

  addingFileUrls = ''

  // Needed for binding dynamically created rule with validator
  mimeTypesRuleKey = snakeCase(Guid.create().toString())

  get self(): FileUrlList {
    return this
  }

  fileLinkInputFieldSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      args.model[args.key] = value
    }
    return args
  }

  inputFileUrls(): void {
    // eslint-disable-next-line require-unicode-regexp
    this.fileUrls.push(this.addingFileUrls.trim())
    this.isAddFilePopupOpen = false
  }

  @Watch('isAddFilePopupOpen')
  onAddFilePopupOpenStateToggle(value: boolean): void {
    if (value) {
      this.$nextTick(() => {
        this.fileLinkInput.$el.querySelector('input').focus()
      })
    }
  }

  get filesData(): Array<FileData> {
    return this.fileUrls.map((url) => {
      let status = FileStatus.Uploaded

      if (
        this.availableMimeTypes
        && !this.availableMimeTypes.includes(String(lookup(url)))
      ) {
        status = FileStatus.InvalidMimeType
      }

      return {
        preview: isImage(url) ? url : '',
        name: url,
        status,
      }
    })
  }

  removeFile(index: number): void {
    this.fileUrls.splice(index, 1)
  }

  removeAllFiles(): void {
    this.$confirm({
      title: this.$t('file_urls_list_remove_all_title').toString(),
      content: this.$t('file_urls_list_remove_all_confirm_text').toString(),
      okText: this.$t('file_urls_list_remove_all_accept').toString(),
      okType: 'danger',
      cancelText: this.$t('file_urls_list_remove_all_reject').toString(),
      centered: true,
      closable: true,
      maskClosable: true,
      onOk: () => {
        this.fileUrls = []
      },
    } as ModalOptions)
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      file_urls_list_button_add_title: 'Добавить ссылку на медиа-файл',
      file_urls_list_popup_title: 'Добавление ссылки',
      file_urls_list_popup_button_add_title: 'Добавить ссылку',
      field_adding_file_urls_title: 'Введите ссылку',

      file_urls_list_remove_all_title: 'Удаление всех файлов',
      file_urls_list_remove_all_confirm_text: 'Вы уверены, что хотите удалить все файлы?',
      file_urls_list_remove_all_accept: 'Удалить',
      file_urls_list_remove_all_reject: 'Отменить удаление',
      file_uploader_delete_all_messages: 'Удалить все файлы',
    })

    this.$i18n.mergeLocaleMessage('en', {
      file_urls_list_button_add_title: 'Add a link to a media file',
      file_urls_list_popup_title: 'Adding a link',
      file_urls_list_popup_button_add_title: 'Add link',
      field_adding_file_urls_title: 'Enter the link',

      file_urls_list_remove_all_title: 'Delete all files',
      file_urls_list_remove_all_confirm_text: 'Are you sure you want to delete all files?',
      file_urls_list_remove_all_accept: 'Delete',
      file_urls_list_remove_all_reject: 'Cancel',
      file_uploader_delete_all_messages: 'Remove all files',
    })

    const hasAvailableMimeTypes = this.availableMimeTypes && this.availableMimeTypes.length

    extend(this.mimeTypesRuleKey, {
      validate: (value) => {
        if (hasAvailableMimeTypes) {
          return this.availableMimeTypes.includes(String(lookup(value)))
        }
        return true
      },
    })

    if (hasAvailableMimeTypes) {
      localize({
        ru: {
          messages: {
            [this.mimeTypesRuleKey]: `Недопустимый тип файла. Список допустимых типов: ${ this.availableMimeTypes.join(', ') }`,
          },
        },
        en: {
          messages: {
            [this.mimeTypesRuleKey]: `Invalid filetype. List of available types is: ${ this.availableMimeTypes.join(', ') }`,
          },
        },
      })
    }
  }
}
